import { Component, HostListener, input, output } from '@angular/core';
import { Perfil } from '../../core/models/perfil.model';
import { formatDateIsoToBr } from '../../core/utils/date-format.util';
import { StatusBadgeComponent } from '../../shared/components/status-badge/status-badge.component';

/**
 * Modal de visualização do perfil exibido a partir da listagem.
 * Reproduz o conteúdo do card de detalhes (`app-perfil-detalhe`) sem sair da tela.
 */
@Component({
  selector: 'app-perfil-visualizar-modal',
  standalone: true,
  imports: [StatusBadgeComponent],
  templateUrl: './perfil-visualizar-modal.component.html',
  styleUrl: './perfil-visualizar-modal.component.scss',
})
export class PerfilVisualizarModalComponent {
  readonly perfil = input.required<Perfil>();

  readonly fechar = output<void>();
  readonly editar = output<number>();

  readonly formatDate = formatDateIsoToBr;

  onFechar(): void {
    this.fechar.emit();
  }

  onEditar(): void {
    this.editar.emit(this.perfil().id);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onFechar();
  }
}